import { uniqueId } from 'lodash'
import { TableHeader as StyledTableHeader, TableRow } from './styles'
import { ColumnProps, ColumnWithPathProps, SortDirection } from './types'

interface TableHeaderProps {
  columns: ColumnProps[]
  sortColumn?: string
  sortDirection?: SortDirection
  onSort?: (sortKey: string) => void
}

const getSortKey = (column: ColumnProps): string => {
  return column.sortKey || (column as ColumnWithPathProps).path || ''
}

const getSortIcon = (
  column: ColumnProps,
  sortColumn?: string,
  sortDirection?: SortDirection
): string => {
  if (!column.sortable) return ''

  const sortKey = getSortKey(column)
  if (sortColumn !== sortKey) return ' ↕'

  return sortDirection === 'asc' ? ' ↑' : ' ↓'
}

const TableHeader = ({
  columns,
  sortColumn,
  sortDirection,
  onSort
}: TableHeaderProps) => {
  const handleHeaderClick = (column: ColumnProps) => {
    if (!column.sortable || !onSort) return

    const sortKey = getSortKey(column)
    onSort(sortKey)
  }

  return (
    <thead>
      <TableRow>
        {columns.map(column => (
          <StyledTableHeader
            key={uniqueId(`${(column as ColumnWithPathProps).path}_`)}
            onClick={() => handleHeaderClick(column)}
            style={{
              cursor: column.sortable ? 'pointer' : 'default',
              userSelect: 'none'
            }}
          >
            {(column as ColumnWithPathProps).label}
            {getSortIcon(column, sortColumn, sortDirection)}
          </StyledTableHeader>
        ))}
      </TableRow>
    </thead>
  )
}

export default TableHeader
